import React from 'react';
const CONFETTI_COLORS = ['#e91e8c', '#7c3aed', '#f472b6', '#a78bfa'];
// Pre-computed confetti pieces so they stay stable across re-renders.
const CONFETTI = Array.from({
  length: 20
}, (_, i) => ({
  id: i,
  left: Math.random() * 100,
  delay: Math.random() * 1,
  color: CONFETTI_COLORS[i % CONFETTI_COLORS.length]
}));
export function ThankYouPage() {
  return <main className="relative w-full min-h-full overflow-x-hidden" style={{
    backgroundColor: '#0a0a0a',
    color: '#ffffff'
  }} data-id="element-1">
      <style data-id="element-2">{`
        @keyframes typFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes typScaleIn {
          from { transform: scale(0); }
          to { transform: scale(1); }
        }
        @keyframes typConfettiFall {
          0% { transform: translateY(-20px); opacity: 1; }
          100% { transform: translateY(220px); opacity: 0; }
        }
        .typ-page { animation: typFadeIn 600ms ease-out both; }
        .typ-icon {
          animation: typScaleIn 400ms ease-out 200ms both;
          transform: scale(0);
        }
        .typ-confetti {
          animation: typConfettiFall 2s ease-in forwards;
        }
      `}</style>

      <div className="typ-page mx-auto" style={{
      maxWidth: 520,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 48,
      paddingBottom: 64
    }} data-id="element-3">
        {/* 1. CONFETTI */}
        <div aria-hidden="true" className="absolute left-0 top-0 w-full overflow-hidden" style={{
        height: 200,
        pointerEvents: 'none',
        zIndex: 0
      }} data-id="element-4">
          {CONFETTI.map(c => <span key={c.id} className="typ-confetti absolute rounded-full" style={{
          top: 0,
          left: `${c.left}%`,
          width: 8,
          height: 8,
          backgroundColor: c.color,
          animationDelay: `${c.delay}s`
        }} data-id="element-5" />)}
        </div>

        {/* 2. SUCCESS ICON */}
        <div className="relative flex justify-center" style={{
        zIndex: 1,
        marginBottom: 24
      }} data-id="element-6">
          <div className="typ-icon flex items-center justify-center rounded-full" style={{
          width: 80,
          height: 80,
          background: 'linear-gradient(135deg, #e91e8c, #7c3aed)'
        }} data-id="element-7">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-8">
              <polyline points="20 6 9 17 4 12" data-id="element-9" />
            </svg>
          </div>
        </div>

        {/* 3. HEADLINE */}
        <h1 className="text-center" style={{
        fontSize: 36,
        fontWeight: 700,
        lineHeight: 1.2,
        color: '#ffffff'
      }} data-id="element-10">
          ¡Todo listo. Tu experiencia con Beatriz está esperándote.
        </h1>

        {/* 4. SUBHEADLINE */}
        <p className="text-center" style={{
        fontSize: 18,
        color: '#9ca3af',
        marginTop: 16,
        lineHeight: 1.5
      }} data-id="element-11">
          Revisa tu email en los próximos minutos para recibir tus accesos. Si
          no llega, revisa spam.
        </p>

        {/* 6. ACCESS BUTTON */}
        <a href="https://hotmart.com" target="_blank" rel="noopener noreferrer" className="block w-full text-center" style={{
        background: 'linear-gradient(135deg, #e91e8c, #7c3aed)',
        color: '#ffffff',
        fontSize: 18,
        fontWeight: 700,
        borderRadius: 9999,
        padding: 20,
        marginTop: 32,
        transition: 'all 200ms ease'
      }} onMouseEnter={e => {
        e.currentTarget.style.opacity = '0.9';
        e.currentTarget.style.transform = 'scale(1.01)';
      }} onMouseLeave={e => {
        e.currentTarget.style.opacity = '1';
        e.currentTarget.style.transform = 'scale(1)';
      }} data-id="element-12">
          Acceder a mis programas en Hotmart →
        </a>
        <p className="text-center" style={{
        fontSize: 13,
        color: '#6b7280',
        marginTop: 12
      }} data-id="element-13">
          Se abrirá Hotmart en una nueva pestaña
        </p>

        {/* 7. NEXT STEPS */}
        <section style={{
        marginTop: 40
      }} data-id="element-14">
          <h2 style={{
          fontSize: 14,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          color: '#9ca3af',
          marginBottom: 16
        }} data-id="element-15">
            Tus próximos pasos:
          </h2>

          <div className="flex flex-col" style={{
          gap: 16
        }} data-id="element-16">
            {[{
            emoji: '📧',
            title: 'Revisa tu email',
            desc: 'Te enviamos los accesos ahora mismo'
          }, {
            emoji: '📱',
            title: 'Descarga la app de Hotmart',
            desc: 'Accede a tus clases desde cualquier lugar'
          }, {
            emoji: '🎯',
            title: 'Empieza hoy',
            desc: 'No lo dejes para mañana — el mejor momento es ahora'
          }].map(item => <div key={item.title} className="flex items-start" style={{
            gap: 12
          }} data-id="element-17">
                <div className="flex flex-shrink-0 items-center justify-center rounded-lg" style={{
              width: 40,
              height: 40,
              backgroundColor: '#1a1a1a',
              fontSize: 18
            }} aria-hidden="true" data-id="element-18">
                  {item.emoji}
                </div>
                <div data-id="element-19">
                  <p style={{
                fontSize: 15,
                fontWeight: 700,
                color: '#ffffff'
              }} data-id="element-20">
                    {item.title}
                  </p>
                  <p style={{
                fontSize: 14,
                color: '#9ca3af',
                lineHeight: 1.5
              }} data-id="element-21">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </section>

        {/* 8. MESSAGE FROM BEATRIZ */}
        <section className="rounded-lg" style={{
        backgroundColor: '#1a1a1a',
        padding: 24,
        marginTop: 40
      }} data-id="element-22">
          <p style={{
          fontSize: 12,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          color: '#e91e8c'
        }} data-id="element-23">
            Un mensaje de Beatriz
          </p>
          <div style={{
          height: 1,
          backgroundColor: '#2a2a2a',
          margin: '12px 0'
        }} data-id="element-24" />
          <blockquote style={{
          fontSize: 16,
          color: '#d1d5db',
          lineHeight: 1.8,
          fontStyle: 'italic',
          margin: 0
        }} data-id="element-25">
            Gracias por confiar en este espacio. Lo que empieza hoy puede
            cambiar mucho más de lo que imaginas.
          </blockquote>
          <p style={{
          fontSize: 14,
          color: '#9ca3af',
          marginTop: 16
        }} data-id="element-26">
            — Beatriz Espina · La DOC
          </p>
        </section>

        {/* 9. SOCIAL SHARE */}
        <section className="text-center" style={{
        marginTop: 40
      }} data-id="element-27">
          <p style={{
          fontSize: 13,
          color: '#6b7280',
          marginBottom: 16
        }} data-id="element-28">
            ¿Conoces a alguien que necesite esto?
          </p>
          <div className="flex justify-center" style={{
          gap: 12
        }} data-id="element-29">
            <a href="https://www.instagram.com/orientaconducta/" target="_blank" rel="noopener noreferrer" className="rounded-full" style={{
            fontSize: 14,
            padding: '8px 20px',
            border: '1px solid #e91e8c',
            color: '#e91e8c',
            backgroundColor: 'transparent',
            transition: 'all 200ms ease'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#e91e8c';
            e.currentTarget.style.color = '#ffffff';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#e91e8c';
          }} data-id="element-30">
              Instagram
            </a>
          </div>
        </section>
      </div>
    </main>;
}